import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PendingPayment } from './PendingPayment';
import HelpWithThisPayment from './HelpWithThisPayment';
import {
  PAGE_PENDING_PAYMENT,
  PAGE_CALL_PAYMENT,
  PAGE_MINIMUM_DISPUTE_THRESHOLD,
  PAGE_HELP_WITH_PAYMENT,
  PAGE_DISPUTE_PAYMENT,
  PAGE_CONTACT_SELLER,
  PAGE_CONTACT_DETAILS,
  PAGE_CLAIM_AMOUNT,
  PAGE_WHAT_DIDNT_YOU_RECEIVE,
  PAGE_DESCRIBE_THE_GOODS,
  PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER,
  PAGE_REVIEW_YOUR_DISPUTE,
  PAGE_WE_HAVE_GOT_IT,
  PAGE_DESCRIBE_THE_TRAVEL_BOOKING,
  GOODS,
  TRAVEL,
  PAGE_DESCRIBE_THE_SERVICE,
  PAGE_MAXIMUM_DISPUTE_THRESHOLD,
} from '../../../constants/FraudAndDisputeConstants';
import { UtilityNav } from 'web-ui-components/lib/navigation/site-navs';
import { UtilityNavButton } from 'web-ui-components/lib/navigation/site-navs';
import { ContactSeller } from './ContactSeller';
import { CallPayment } from './CallPayment';
import { DisputePayment } from './DisputePayment';
import { ContactDetails } from './ContactDetails';
import UserManagementStore from '../../../stores/UserManagementStore';
import { ClaimAmount } from './ClaimAmount';
import { WhatDidntYouReceive } from './WhatDidntYouReceive';
import { DescribeTheGoods } from './DescribeTheGoods';
import { WhatHappened } from './WhatHappened';
import { ReviewYourDispute } from './ReviewYourDispute';
import { WeHaveGotIt } from './WeHaveGotIt';
import { DescribeTheTravelBooking } from './DescribeTheTravelBooking';
import FraudAndDisputeActionCreator from '../../../actions/FraudAndDisputeActionCreator';
import FraudAndDisputeStore from '../../../stores/FraudAndDisputeStore';
import { DescribeTheService } from './DescribeTheService';
import { MaximumThreshold, MinimumThreshold } from './ThresholdMessage';

const PAGES_WITHOUT_BACK_NAV = [
  PAGE_WE_HAVE_GOT_IT,
  PAGE_MAXIMUM_DISPUTE_THRESHOLD,
];

export class LayoutContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: PAGE_HELP_WITH_PAYMENT,
      previousPage: '',
      openDisputePaymentModal: false,
    };
  }

  setPage = (nextPage, fromPage = '') => {
    this.setState({ page: nextPage, previousPage: fromPage });
  };

  closeDisputePaymentModal = () => {
    this.setState({ openDisputePaymentModal: false });
  };
  render() {
    const { content, data, logoInitials, setShowDisputeForm } = this.props;
    const { page, openDisputePaymentModal } = this.state;

    const user = UserManagementStore.getCADetails();

    const getPage = (page) => {
      switch (page) {
        case PAGE_HELP_WITH_PAYMENT:
          return (
            <HelpWithThisPayment
              content={content}
              setPage={this.setPage}
              data={data}
              logoInitials={logoInitials}
              openDisputePaymentModal={openDisputePaymentModal}
              closeDisputePaymentModal={this.closeDisputePaymentModal}
            />
          );
        case PAGE_CONTACT_SELLER:
          return <ContactSeller content={content} setPage={this.setPage} />;
        case PAGE_PENDING_PAYMENT:
          return (
            <PendingPayment
              content={content}
              goBack={() => setShowDisputeForm(false)}
            />
          );
        case PAGE_CALL_PAYMENT:
          return <CallPayment content={content} />;
        case PAGE_MINIMUM_DISPUTE_THRESHOLD:
          return (
            <MinimumThreshold
              content={content}
              onConfirm={() => setShowDisputeForm(false)}
            />
          );
        case PAGE_MAXIMUM_DISPUTE_THRESHOLD:
          return (
            <MaximumThreshold
              content={content}
              onConfirm={() => this.setPage(PAGE_HELP_WITH_PAYMENT)}
            />
          );
        case PAGE_DISPUTE_PAYMENT:
          return (
            <DisputePayment
              content={content}
              setPage={this.setPage}
              data={data}
              logoInitials={logoInitials}
              closeDisputePaymentModal={this.closeDisputePaymentModal}
            />
          );
        case PAGE_CONTACT_DETAILS:
          return (
            <ContactDetails
              content={content}
              setPage={this.setPage}
              userDetails={user}
            />
          );
        case PAGE_CLAIM_AMOUNT:
          return (
            <ClaimAmount content={content} setPage={this.setPage} data={data} />
          );
        case PAGE_WHAT_DIDNT_YOU_RECEIVE:
          return (
            <WhatDidntYouReceive content={content} setPage={this.setPage} />
          );
        case PAGE_DESCRIBE_THE_GOODS:
          return <DescribeTheGoods content={content} setPage={this.setPage} />;
        case PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER:
          return <WhatHappened content={content} setPage={this.setPage} />;
        case PAGE_REVIEW_YOUR_DISPUTE:
          return (
            <ReviewYourDispute
              content={content}
              setPage={this.setPage}
              userDetails={user}
              transactionDetails={data}
              logoInitials={logoInitials}
            />
          );
        case PAGE_WE_HAVE_GOT_IT:
          return (
            <WeHaveGotIt
              content={content}
              setShowDisputeForm={setShowDisputeForm}
            />
          );
        case PAGE_DESCRIBE_THE_TRAVEL_BOOKING:
          return (
            <DescribeTheTravelBooking
              content={content}
              setPage={this.setPage}
            />
          );
        case PAGE_DESCRIBE_THE_SERVICE:
          return (
            <DescribeTheService content={content} setPage={this.setPage} />
          );
        default:
          return null;
      }
    };

    const getBackbutton = (page) => {
      switch (page) {
        case PAGE_HELP_WITH_PAYMENT:
          return () => {
            setShowDisputeForm(false);
          };
        case PAGE_CONTACT_SELLER:
          return () => {
            this.setState({ openDisputePaymentModal: true });
            this.setPage(PAGE_HELP_WITH_PAYMENT);
          };
        case PAGE_PENDING_PAYMENT:
          return () => {
            this.setPage(PAGE_DISPUTE_PAYMENT);
          };
        case PAGE_CALL_PAYMENT:
          return () => {
            this.setPage(
              this.state.previousPage === PAGE_DISPUTE_PAYMENT
                ? PAGE_DISPUTE_PAYMENT
                : PAGE_HELP_WITH_PAYMENT
            );
            this.state.previousPage !== PAGE_DISPUTE_PAYMENT &&
              this.setState({ openDisputePaymentModal: true });
          };
        case PAGE_MINIMUM_DISPUTE_THRESHOLD:
          return () => {
            this.setPage(PAGE_DISPUTE_PAYMENT);
          };
        case PAGE_DISPUTE_PAYMENT:
          return () => {
            this.setPage(PAGE_CONTACT_SELLER);
          };
        case PAGE_CONTACT_DETAILS:
          return () => {
            this.setPage(PAGE_DISPUTE_PAYMENT);
          };
        case PAGE_CLAIM_AMOUNT:
          return () => {
            this.setPage(PAGE_CONTACT_DETAILS);
          };
        case PAGE_WHAT_DIDNT_YOU_RECEIVE:
          return () => {
            this.setPage(PAGE_CLAIM_AMOUNT);
          };
        case PAGE_DESCRIBE_THE_GOODS:
        case PAGE_DESCRIBE_THE_TRAVEL_BOOKING:
        case PAGE_DESCRIBE_THE_SERVICE:
          return () => {
            this.setPage(PAGE_WHAT_DIDNT_YOU_RECEIVE);
          };
        case PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER:
          return () => {
            FraudAndDisputeActionCreator.displayReviewScreen(false);
            this.setPage(
              FraudAndDisputeStore.getDisputeJourneyType() === GOODS
                ? PAGE_DESCRIBE_THE_GOODS
                : FraudAndDisputeStore.getDisputeJourneyType() === TRAVEL
                ? PAGE_DESCRIBE_THE_TRAVEL_BOOKING
                : PAGE_DESCRIBE_THE_SERVICE
            );
          };
        case PAGE_REVIEW_YOUR_DISPUTE:
          return () => {
            FraudAndDisputeActionCreator.displayReviewScreen(false);
            this.setPage(PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER);
          };
        default:
          return null;
      }
    };

    return (
      <div>
        <UtilityNav
          leftContent={
            !PAGES_WITHOUT_BACK_NAV.includes(page) && (
              <UtilityNavButton.Back onClick={getBackbutton(page)} />
            )
          }
        />
        {getPage(page)}
      </div>
    );
  }
}

LayoutContainer.propTypes = {
  content: PropTypes.object,
  data: PropTypes.object,
  logoInitials: PropTypes.string,
  setShowDisputeForm: PropTypes.func,
};

export default LayoutContainer;
